import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=b09c0b06&scoped=true&lang=css"

import exportComponent from "F:\\MUZI\\com-muzimuzi-saas\\muzi-saas-admin-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b09c0b06"]])

export default __exports__